SlideView = require("views/slide")
Preloader = require("lib/preload")

class ParallaxView extends SlideView
  template: require("./template")
  useMouseEvent: true

  events: ->
    "iostap .btn-done": "next"
    "mousemove": "onMouseMove"

  serialize: ->
    data = super
    data.images = _.compact data.images
    data

  beforeShow: ->
    Preloader.load @options.data.images, =>
      @onRotate(beta: 0, gamma: 0)

  show: ->
    @setEl @findAll(".parallax-img"), "images"
    @setEl @findOne(".caption"), "caption"

    if @options.data.background
      @trigger "ui", lightbox: @options.data.background

    return unless window.Promise?

    @gn = new GyroNorm()
    @gn.init(frequency: 150)
      .catch(-> console?.log("DeviceOrientation not available in this context"))
      .then  =>
        @gn.start (data) =>
          # Annoyingly, iframes in the LMS don't reject the Promise,
          # so we need to ensure that the event is really available.
          if not @useMouseEvent or @gn.isAvailable().deviceOrientationAvailable
            @useMouseEvent = false
            @onRotate data.do, "all 300ms"

  hide: ->
    @gn?.end()

  onRefresh: ->
    @gn?.end()
    @show()

    unless @options.data.background
      @trigger "ui", lightbox: false

  undelegateEvents: ->
    $(window).off(".#{@cid}")
    super

  onMouseMove: (e) ->
    return unless @useMouseEvent
    e.stopImmediatePropagation?()

    { pageX, pageY } = e.touches?[0] or e

    gamma = (pageX / @el.offsetWidth - 0.5 ) * 90
    beta  = (pageY / @el.offsetHeight - 0.5) * 90

    @onRotate { beta, gamma }

  onRotate: ({ beta, gamma }, transition = "") ->
    images = @getEl("images")
    return unless images

    length  = images.length - (1 - images.length % 2)
    dampenX = 0.3
    dampenY = 0.25

    g = dampenX * gamma
    b = dampenY * beta

    offsetY = -@getEl("caption")?.offsetHeight / 2 or 0

    for img, i in images
      @transform img,
        x: g * (-length / 2 + i + 1) - img.offsetWidth / 2
        y: b * (-length / 2 + i + 1) - img.offsetHeight / 2 + offsetY
        transition: transition


module.exports = ParallaxView
